const BookingTypeMetadataView = {
    template: require('./booking-type-metadata.view.component.html'),
    controller: () => {},
    bindings: {
        ngModel: '<',
        metadata:'<',
    },
    bindToController: true,
    controllerAs: 'vm'
};

export default BookingTypeMetadataView;